import { render } from "./Featured.vue?vue&type=template&id=597df376&scoped=true&ts=true"
import script from "./Featured.vue?vue&type=script&lang=ts"
export * from "./Featured.vue?vue&type=script&lang=ts"

import "./Featured.vue?vue&type=style&index=0&id=597df376&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597df376"]])

export default __exports__